"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.palette = void 0;
var palette = {
  blue10: '#E5EDFD',
  blue20: '#CCDCFC',
  blue30: '#B2CAFA',
  blue40: '#99B9F9',
  blue50: '#7FA7F7',
  blue60: '#6695F5',
  blue70: '#4C83F3',
  blue80: '#2B6BED',
  blue90: '#1960F0',
  blue100: '#004FEF',
  charcoal: '#1D1D1D',
  powder: '#FCFCFC',
  white: '#FFFFFF',
  purple10: '#F5F1FC',
  purple20: '#EDE7F6',
  purple30: '#DED4ED',
  purple40: '#D2C5E7',
  purple50: '#C4B3DD',
  purple60: '#B8A4D7',
  purple70: '#A992CC',
  purple80: '#997EC3',
  purple90: '#8363B6',
  purple100: '#643BA2',
  red10: '#FFECEE',
  red20: '#FFDBDE',
  red30: '#FFC8CE',
  red40: '#FFB6BE',
  red50: '#FFA4AD',
  red60: '#FF929D',
  red70: '#FF7F8C',
  red80: '#FF7080',
  red90: '#FF5B6C',
  red100: '#FF495C',
  green10: '#EBFBF4',
  green20: '#D8F8EA',
  green30: '#C4F4DF',
  green40: '#B1F1D5',
  green50: '#9EEDCB',
  green60: '#8BEAC1',
  green70: '#77E6B6',
  green80: '#64E3AC',
  green90: '#50DFA1',
  green100: '#3DDC97',
  danger10: '#FAE0E1',
  danger20: '#F6C3C4',
  danger30: '#F0A6A8',
  danger40: '#EC8D8F',
  danger50: '#E36E71',
  danger60: '#DC5A5E',
  danger70: '#D4363E',
  danger80: '#CE2530',
  danger90: '#C30000',
  danger100: '#B30000',
  warning10: '#FEEEE2',
  warning20: '#FDDFC8',
  warning30: '#FBD0AC',
  warning40: '#F9C59A',
  warning50: '#FFBA83',
  warning60: '#F5AC70',
  warning70: '#F0A15F',
  warning80: '#EC9344',
  warning90: '#E88729',
  warning100: '#E17A17',
  info10: '#EFF8FF',
  info20: '#D7ECFF',
  info30: '#AAD6FF',
  info40: '#97CDFF',
  info50: '#8CC7FF',
  info60: '#7FC0FD',
  info70: '#72B9FD',
  info80: '#61B2FF',
  info90: '#51A7FA',
  info100: '#1E90FF',
  success10: '#DEF1E0',
  success20: '#BEE4C3',
  success30: '#9ED5A5',
  success40: '#7FC889',
  success50: '#63BE71',
  success60: '#45B55A',
  success70: '#11A941',
  success80: '#0C9D24',
  success90: '#007E00',
  success100: '#008000',
  gray00: '#FCFCFC',
  gray10: '#F6F6F6',
  gray20: '#F0F0F0',
  gray30: '#E8E8E8',
  gray40: '#E3E3E3',
  gray50: '#D9D9D9',
  gray60: '#D2D2D2',
  gray70: '#CACACA',
  gray80: '#C3C3C3',
  gray90: '#BBBBBB',
  gray100: '#B4B4B4',
  blueGray10: '#E7E7E8',
  blueGray20: '#CFCFD3',
  blueGray30: '#B8B8BD',
  blueGray40: '#A1A2A8',
  blueGray50: '#8B8C94',
  blueGray60: '#737585',
  blueGray70: '#61626D',
  blueGray80: '#4D4E5A',
  blueGray90: '#3A3A47',
  blueGray100: '#2D2F3D'
};
exports.palette = palette;
var _default = {
  //** BRAND COLORS **//
  // BLUE
  brandPrimary: palette.blue100,
  brandPrimaryInteract: palette.blue90,
  brandPrimaryContrast: palette.white,
  // GREEN
  brandSecondaryLight: palette.green20,
  brandSecondary: palette.green100,
  brandSecondaryInteract: palette.green90,
  brandSecondaryContrast: palette.charcoal,
  // CHARCOAL
  brandSupporting01: palette.charcoal,
  brandSupporting01Contrast: palette.white,
  // POWDER
  brandSupporting02: palette.powder,
  brandSupporting02Contrast: palette.charcoal,
  // PURPLE
  brandSupporting03: palette.purple100,
  brandSupporting03Contrast: palette.white,
  // RED
  brandSupporting04: palette.red100,
  brandSupporting04Contrast: palette.white,
  //** UI COLORS **//
  // TEXT
  text00: palette.charcoal,
  text01: palette.blueGray100,
  text02: palette.blueGray70,
  text03: palette.white,
  textLinkVisited: palette.purple100,
  textMuted: palette.blueGray40,
  // UI
  ui00: palette.white,
  ui01: palette.gray00,
  ui02: palette.gray10,
  ui03: palette.gray20,
  ui04: palette.gray30,
  ui05: palette.blueGray100,
  uiError: palette.danger70,
  uiErrorContrast: palette.white,
  uiErrorInteract: palette.danger60,
  uiInfo: palette.blue100,
  uiInfoContrast: palette.white,
  uiInfoInteract: palette.blue90,
  uiSuccess: palette.success90,
  uiSuccessContrast: palette.white,
  uiSuccessInteract: palette.success80,
  uiWarning: palette.warning70,
  uiWarningContrast: palette.charcoal,
  uiWarningInteract: palette.warning60,
  textHighlight: {
    primary: {
      textColor: palette.white,
      backgroundColor: palette.blue100
    },
    secondary: {
      textColor: palette.white,
      backgroundColor: palette.blue100
    },
    alternate1: {
      textColor: palette.charcoal,
      backgroundColor: palette.green100
    },
    alternate2: {
      textColor: palette.white,
      backgroundColor: palette.purple100
    }
  }
};
exports.default = _default;